import { tv } from 'tailwind-variants';

const inputStyles = tv({
    slots: {
        input: `
      iris:peer
      iris:gap-(--comp-space-gap-input)
      iris:pt-(--comp-space-padding-text-input-inner-label-filled-top)
      iris:pb-(--comp-space-padding-text-input-inner-label-filled-bottom)
      iris:font-(family-name:--comp-type-font-input-value)
      iris:text-(length:--comp-type-size-input-value)
      iris:leading-(--comp-type-leading-input-value)!
      iris:tracking-(--comp-type-tracking-input-value)
      iris:duration-(--comp-motion-duration-text-input) 
      iris:ease-(--comp-motion-easing-text-input)
      iris:hover:border-(--comp-color-border-input-hover)
      iris:focus:pt-(--comp-space-padding-text-input-inner-label-filled-top)
      iris:focus:pb-(--comp-space-padding-text-input-inner-label-filled-bottom)
      iris:focus-visible:ring-2
      iris:focus-visible:ring-offset-2
      iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
    `,
        label: `
      iris:cursor-auto
      iris:transition-all
      iris:duration-(--comp-motion-duration-text-input)
      iris:ease-(--comp-motion-easing-text-input)
      iris:peer-disabled:cursor-not-allowed
      iris:peer-disabled:opacity-(--sem-opacity-interactive-disabled)
    `,
        labelInner: `
      iris:absolute
      iris:top-(--base-space-px-8)
      iris:left-[var(--comp-size-border-input)]
      iris:px-(--comp-space-padding-input-horizontal)
      iris:font-(family-name:--comp-type-font-input-inner-label)
      iris:text-(length:--comp-type-size-input-inner-label)
      iris:leading-(--comp-type-leading-input-inner-label)
      iris:font-(--comp-type-weight-input-inner-label)!
      iris:tracking-(--comp-type-tracking-input-inner-label)
      iris:peer-focus:top-(--base-space-px-8)
      iris:peer-focus:translate-y-0
      iris:peer-focus:text-(length:--comp-type-size-input-inner-label)
    `,
        wrapper: `
      iris:flex
      iris:flex-col
      iris:gap-(--comp-space-gap-input)
    `,
        labelInputWrapper: `
      iris:relative
      iris:flex
      iris:flex-col
    `,
    },
    variants: {
        variant: {},
        inverse: {
            true: {
                label: `
          iris:peer-focus:text-(--comp-color-content-input-label-inverse-active)
          iris:peer-focus:hover:text-(--comp-color-content-input-label-inverse-active)
        `,
                input: `
          iris:hover:border-(--comp-color-border-input-inverse-hover)
          iris:focus-visible:border-(--comp-color-border-input-inverse-active)
          iris:focus-visible:ring-(--comp-color-border-input-inverse-active)
          iris:focus-visible:ring-offset-(--sem-color-background-neutral-inverse-primary)
          iris:focus-visible:outline-none
          iris:disabled:border-(--comp-color-border-input-inverse-rest)
        `,
            },
            false: {
                input: `
          iris:focus-visible:border-(--comp-color-border-input-active)
          iris:focus-visible:ring-(--comp-color-border-input-active)
          iris:disabled:border-(--comp-color-border-input-rest)
          `,
                label: `
          iris:peer-focus:text-(--comp-color-content-input-label-active)
          iris:peer-focus:hover:text-(--comp-color-content-input-label-active)
        `,
            },
        },
        error: {
            true: {
                label: `
          iris:text-(--comp-color-content-input-label-error)
          iris:peer-focus:text-(--comp-color-content-input-label-error)
          iris:hover:text-(--comp-color-content-input-label-error)
          iris:peer-focus:hover:text-(--comp-color-content-input-label-error)
        `,
                input: `
          iris:border-(--comp-color-border-input-error)
          iris:bg-(--comp-color-background-input-error)
          iris:peer-focus:text-(--comp-color-content-input-helper-error)
          iris:hover:border-(--comp-color-border-input-error)
          iris:hover:bg-(--comp-color-background-input-error)
          iris:focus:bg-(--comp-color-background-input-error)
          iris:focus-visible:border-(--comp-color-content-input-label-error)
          iris:disabled:border-(--comp-color-border-input-error)
          iris:disabled:hover:border-(--comp-color-border-input-error)
        `,
            },
        },
        disabled: {
            true: {},
            false: {},
        },
    },
    compoundVariants: [
        {
            inverse: true,
            error: true,
            class: {
                label: `
          iris:text-(--comp-color-content-input-label-inverse-error)
          iris:peer-focus:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-error)
          iris:peer-focus:hover:text-(--comp-color-content-input-label-inverse-error)
        `,
                input: `
          iris:border-(--comp-color-border-input-inverse-error)
          iris:bg-(--comp-color-background-input-inverse-rest)
          iris:hover:border-(--comp-color-border-input-inverse-error)
          iris:hover:bg-(--comp-color-background-input-inverse-rest)
          iris:focus:bg-(--comp-color-background-input-inverse-rest)
          iris:focus-visible:border-(--comp-color-border-input-inverse-error)
          iris:disabled:border-(--comp-color-border-input-inverse-error)
          iris:disabled:hover:border-(--comp-color-border-input-inverse-error)
        `,
            },
        },
    ],
    defaultVariants: {
        inverse: false,
        error: false,
        disabled: false,
    },
});

export { inputStyles as default };
